import { useState, useEffect, useCallback } from 'react';
import { lessonProgressService, LessonProgress } from '../services/lessonProgress';

export const useLessonProgress = (lessonId: string) => {
  const [progress, setProgress] = useState<LessonProgress>({
    lessonId,
    watched: false,
    liked: null
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Load progress
  useEffect(() => {
    const loadProgress = async () => {
      try {
        const results = await lessonProgressService.loadProgress([lessonId]);
        setProgress(results[lessonId] || { lessonId, watched: false, liked: null });
        setError(null);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Erro ao carregar progresso');
      } finally {
        setLoading(false);
      }
    };

    loadProgress();
  }, [lessonId]);

  // Toggle watched status
  const toggleWatched = useCallback(async () => {
    try {
      const newWatched = !progress.watched;
      setProgress(prev => ({ ...prev, watched: newWatched }));
      await lessonProgressService.updateProgress(lessonId, { watched: newWatched });
      setError(null);
    } catch (err) {
      setProgress(prev => ({ ...prev, watched: !prev.watched })); // Revert on error
      setError(err instanceof Error ? err.message : 'Erro ao atualizar progresso');
    }
  }, [lessonId, progress.watched]);

  // Update like status
  const updateLike = useCallback(async (liked: boolean | null) => {
    try {
      setProgress(prev => ({ ...prev, liked }));
      await lessonProgressService.updateProgress(lessonId, { liked });
      setError(null);
    } catch (err) {
      setProgress(prev => ({ ...prev, liked: prev.liked })); // Revert on error
      setError(err instanceof Error ? err.message : 'Erro ao atualizar avaliação');
    }
  }, [lessonId]);

  return {
    progress,
    loading,
    error,
    toggleWatched,
    updateLike
  };
};
